import { Routes } from '@angular/router';
import { authGuard } from '@shared/guards/auth.guard';
import { loginGuard } from '@shared/guards/login.guard';
import { terminosGuard } from '@shared/guards/terminos.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((x) => x.routes),
    canActivate: [loginGuard],
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.routes').then((m) => m.routes),
    canActivate: [authGuard, terminosGuard],
  },
  {
    path: 'info',
    loadChildren: () => import('./info/info.routes').then((m) => m.routes),
  },
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  {
    path: '**',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
];
